module.exports = __webpack_public_path__ + "media/images/views/home/home-features-icon-planning-879f50b42399021893c65e8a954e05c3.png";